<div class="h-full overflow-y-auto use-scrollbar overflow-x-hidden box-border">
  <!--
    a11y: close (X) reordered to be FIRST in DOM. The back button stays in
    its original slot (order-1, visually leading). Close keeps order-2,
    trailing side. Rendered on mobile too so every viewport has a focusable
    close target. Note: this view is the second screen of the special-
    messages dialog — the parent already focused its close on dialog open.
  -->
  <div class="flex justify-between items-center mb-4 ">
    <mot-button matType="icon" icon="close"
      [ariaLabel]="closeText"
      class="!border-none !w-min !h-min cursor-pointer !bg-transparent order-2" iconClass="!text-2xl"
      (onClick)="onClose.emit()" />
    <div class="flex gap-2 items-center order-1">
      <mot-button [icon]="backIcon" iconClass="!text-sm !w-4 !h-4" buttonClass="!w-4 !h-4 !p-4"
        (onClick)="onGoBack.emit()" [text]="backText" />
    </div>
  </div>
    <app-special-message-pop-up-header [message]="selectedMessage" [isShowHeader]="isShowHeader()" />
    <hr class="border-gray-500 border-t-1 w-full opacity-50 m-0 my-2" />
    <!-- <p class="font-normal" [innerHTML]="descText"></p>
    <div class="flex flex-col gap-2 pb-2">
      <div class="flex flex-col pr-4 border-r-2 border-r-blue-500 border-t-0 border-b-0 border-l-0 border-solid">
        <span>{{affectedLinesText}}</span>
        <span class="font-normal">{{selectedMessage.allAffectedRoutesNames.join(', ')}}</span>
      </div>
      <div class="pr-4 border-r-2 border-r-blue-500 border-t-0 border-b-0 border-l-0 border-solid">
        <span>{{affectedStationsText}}</span>
        <ul class="p-0 list-none m-0">
          <li class="font-normal" *ngFor="let stopName of selectedMessage.allAffectedStopsNames">{{stopName}}</li>
        </ul>
      </div>
    </div> -->
    <div class="flex flex-col gap-2 pb-2">
      <div>
        <span>{{inLinesText}}: </span>
        <span class="font-normal">{{selectedMessage.allAffectedRoutesNames.join(', ')}}</span>
      </div>

      <span>{{effectText}} {{dueToText | lowercase}} {{causeText | lowercase}}</span>
      @if (selectedMessage.effect.id === effects.NO_SERVICE || this.selectedMessage.effect.id === effects.DETOUR || this.selectedMessage.effect.id === effects.STOP_MOVED) {
        <div class="flex flex-col gap-2"
          >
          <div>
            @if (selectedMessage.allAffectedStops && selectedMessage.allAffectedStops.length) {
              <div>
                <ul class="p-0 list-none m-0">
                  @for (stopData of selectedMessage.allAffectedStops; track stopData) {
                    <li class="font-normal">{{stopData.stationName}} - {{stopData.stationCode}}</li>
                  }
                </ul>
              </div>
            }
          </div>
          @if (selectedMessage.alternativeStops && selectedMessage.alternativeStops.length) {
            <div
              class="flex flex-col">
              <span>{{insteadLinesWillGoText}}:</span>
              <ul class="p-0 list-none m-0">
                @for (stopData of selectedMessage.alternativeStops; track stopData) {
                  <li class="font-normal">{{lineText}}
                    {{stopData.routeName}} - {{stopData.alternativeStationName}} -
                  {{stopData.alternativeStationCode}}</li>
                }
              </ul>
            </div>
          }
        </div>
      }

      @if (showAdditionalInfo) {
        <div>
          <hr class="border-gray-500 border-t-1 w-full opacity-50 m-0 my-2" />
          <p class="font-normal" [innerHTML]="descText"></p>
        </div>
      }
      @if (isShowAdditionalInfo()) {
        <mot-button (onClick)="this.showAdditionalInfo = !this.showAdditionalInfo"
          [text]="!this.showAdditionalInfo ? showInfoText : hideInfoText"
          [ariaExpanded]="showAdditionalInfo"
          buttonClass="!bg-primary !text-white !px-2 !py-3 !rounded-lg !align-middle mt-0.5" />
      }

      @if (!isShowAdditionalInfo()) {
        <p>{{forMoreInfoText}}</p>
      }
    </div>
  </div>